import { Box, makeUclComponent } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { ExternalLink } from 'components/external-link';
import { LayoutContainer } from 'components/layout/styled';
import PictureComponent from 'components/picture';
import { getDesignToken } from 'styles/constants';

export const LayoutContainerBackground = LayoutContainer.withConfig({
  backgroundColor: getDesignToken('background-focus'),
  marginTop: '150px',
  paddingBottom: {
    base: '$6',
    md: '$0',
  },
});

export const Section = Box.withConfig({
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',

  _web: {
    padding: 0,
    alignItems: 'stretch',
    overflow: 'visible',

    flexDirection: {
      sm: 'column',
      md: 'row',
    },
  },
});

export const ImageDesktop = Box.withConfig({
  flex: 1,
  display: {
    base: 'none',
    md: 'flex',
  },
});

export const TextHalf = Box.withConfig({
  flex: 1,
  paddingTop: {
    base: '$0',
    md: '$12',
  },
  paddingBottom: {
    base: '$0',
    md: '$20',
  },

  alignItems: {
    base: 'center',
    md: 'flex-start',
  },
  width: 'full',
});

export const ImageMobile = Box.withConfig({
  maxWidth: '$40',
  flex: 1,
  bottom: 0,
  right: '$0',
  display: {
    base: 'flex',
    md: 'none',
  },
  height: '$48',
});

export const MainImageContainer = Box.withConfig({
  height: '100%',
  bottom: '10%',
  px: '10%',
  paddingBottom: '$10',
});

export const Picture = PictureComponent.withConfig({
  width: '100%',
  height: '110%',
});

export const PictureMobile = Picture.withConfig({
  position: 'absolute',
  height: '$56',
  bottom: '$0',
});

export const Header = withTypography({
  fontFamily: 'heading',
  bold: true,
  fontSize: '3xl',
  lineHeight: 34,
});

export const Description = withTypography({ mt: '$8' });

export const BadgesContainer = Box.withConfig({
  flexDirection: 'row',
  gap: {
    base: '$5',
    md: '$0',
  },
  marginTop: {
    base: '$4',
    md: '$8',
  },
});

export const BadgeLink = makeUclComponent(ExternalLink).withConfig({
  marginRight: {
    base: '$0',
    md: '$2',
    lg: '$6',
  },
});

export const Disclaimer = withTypography({
  fontSize: 'sm',
  textAlign: 'center',
  mt: '$4',
});

export const HeaderContainer = Box.withConfig({
  flex: 1,
  justifyContent: 'center',
  paddingLeft: {
    base: '$4',
    md: '$0',
  },
});
